export const MaskIcon = ({
  src,
  width = 20,
  height = 20,
  onClick,
  color = "#8F0D3D",
  style = {},
}) => (
  <div
    style={{
      width,
      height,
      backgroundColor: color,
      WebkitMask: `url(${src}) center / contain no-repeat`,
      mask: `url(${src}) center / contain no-repeat`,
      display: "inline-block",
      flexShrink: 0,
      ...style,
    }}
    onClick={onClick}
  />
);